module.exports = __webpack_public_path__ + "static/media/img-08.e8933b88.jpg";